// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2fpCt","image":"Header_image__3cI6Z","name":"Header_name__1PJe2","info":"Header_info__I1KR5","infoRow":"Header_infoRow__1iYQc"};